import { jpegBytesFromDataUrl } from '../ui/screenshot';
import { RemoteError, type RemoteApi } from './remoteApi';

export interface FeedbackDraft {
  id: string;
  kind: 'bug' | 'idea';
  message: string;
  gameVersion: string;
  userAgent: string;
  stage: number;
  errors: string[];
  saveVersion: number;
  url: string;
  screenshotDataUrl: string | null;
}

export function feedbackDraft(input: {
  kind: 'bug' | 'idea';
  message: string;
  gameVersion: string;
  userAgent: string;
  stage: number;
  errors: string[];
  saveVersion: number;
  url: string;
  screenshotDataUrl?: string | null;
}): FeedbackDraft {
  const message = input.message.replace(/\s+/g, ' ').trim().slice(0, 2000);
  return {
    id: crypto.randomUUID(),
    kind: input.kind,
    message,
    gameVersion: input.gameVersion.slice(0, 80) || 'dev',
    userAgent: input.userAgent.replace(/\s+/g, ' ').trim().slice(0, 400),
    stage: Math.max(0, Math.min(999, Math.floor(input.stage) || 0)),
    errors: input.errors.slice(-20).map((line) => line.slice(0, 240)),
    saveVersion: Math.max(0, Math.floor(input.saveVersion) || 0),
    url: input.url.slice(0, 500),
    screenshotDataUrl: input.screenshotDataUrl ?? null,
  };
}

export async function deliverFeedback(api: RemoteApi, report: FeedbackDraft): Promise<void> {
  if (!api.insertFeedback) throw new RemoteError('save_invalid', 'feedback_unavailable');
  await api.insertFeedback({
    id: report.id,
    kind: report.kind,
    message: report.message,
    game_version: report.gameVersion,
    user_agent: report.userAgent,
    current_stage: report.stage,
    recent_errors: report.errors,
    save_version: report.saveVersion,
    url: report.url,
  });
  const bytes = report.screenshotDataUrl ? jpegBytesFromDataUrl(report.screenshotDataUrl) : null;
  if (!bytes || !api.uploadFeedbackShot || !api.attachFeedbackScreenshot) return;
  const user = await api.currentUser();
  if (!user) return;
  const path = `${user.id}/${report.id}.jpg`;
  try {
    await api.uploadFeedbackShot(path, bytes);
    await api.attachFeedbackScreenshot(report.id);
  } catch {
    // The report row is already stored. A failed shot does not undo it.
  }
}
